import { Theme } from './types'

export interface ThemeCapabilities {
  supportsDarkMode: boolean
}

export const THEME_CAPABILITIES: Record<Theme, ThemeCapabilities> = {
  [Theme.AP]: {
    supportsDarkMode: false,
  },
  [Theme.Cash]: {
    supportsDarkMode: false,
  },
  [Theme.Pegasus]: {
    supportsDarkMode: true,
  },
  [Theme.Kelpie]: {
    supportsDarkMode: true,
  },
  [Theme.KelpieMint]: {
    supportsDarkMode: true,
  },
}

export const themeSupportsDarkMode = (theme: Theme): boolean => {
  return THEME_CAPABILITIES[theme]?.supportsDarkMode ?? false
}
